/* eslint-disable import/no-anonymous-default-export */
import apiClient from "./api";

export default {
  createPaymentIntent(payload) {
    return apiClient.post("/api/payments/create-payment-intent", payload);
  },
  savePaypalPaymentInfo(payload) {
    return apiClient.post("/api/payments/save-payment", payload);
  },
  updateMembership(payload) {
    return apiClient.post("/api/payments/membership/update", payload);
  },
  enterpriseContact(payload) {
    return apiClient.post("/api/payments/enterprise/contact", payload);
  },
  pioneerMessage(payload) {
    return apiClient.post("/api/payments/pioneer/message", payload);
  },
  createSession(data) {
    return apiClient.post("/api/payments/create-checkout-session", data);
  },
  createPortalSession(data) {
    return apiClient.post("/api/payments/create-customer-portal", data);
  },
  getcheckoutSession(data) {
    return apiClient.post("/api/payments/get-checkout-session", data);
  },
};
